module.exports = __webpack_public_path__ + "img/sedan.72dbf6b6.png";